import { render, staticRenderFns } from "./footer.html?vue&type=template&id=6caf2089&scoped=true&external"
import script from "./footer.js?vue&type=script&lang=js&external"
export * from "./footer.js?vue&type=script&lang=js&external"
import style0 from "./footer.css?vue&type=style&index=0&id=6caf2089&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf2089",
  null
  
)

export default component.exports